<template>
  <div id="app">
    <!-- Show the loader until the user data is fully loaded -->
    <div v-if="loading" class="loader">
      <div>
        <img src="@/assets/images/logo-sm.png" alt="" class="profile-wid-img" />
      </div>
      <b-spinner variant="info" label="Loading..."></b-spinner>
      <p>{{ $t('loader-text') }}</p>
    </div>

    <!-- Render the app only after user data is fully loaded -->
    <router-view v-if="!loading"></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getUserTheme, watchTheme } from "./helpers/theme";

import { layoutMethods } from "@/state/helpers";

export default {
  name: 'App',
  data() {
    return {
      loading: true, // Start with loading enabled
    };
  },
  async created() {
    this.initializeTheme();
    
    const user = localStorage.getItem('ENSPSID');
    
    if (user) {
      try {
        // Load user profile before rendering the app
        await this.$store.dispatch('authfack/getProfile');

        // Load other required data after the profile
        await Promise.all([
          this.fetch_years(),
          this.fetch_totals(),
          this.fetch_companies(),
          this.fetch_industries(),
        ]);
      } catch (error) {
        console.error("Error loading profile:", error);
      }
    }

    // Now we can show the app
    this.loading = false;
  },
  methods: {
    ...layoutMethods,
    ...mapActions({
      fetch_years: 'year/fetch_years',
      fetch_totals: 'year/fetch_totals',
      fetch_companies: 'company/fetch_companies',
      fetch_industries: 'industry/fetch_industries',
    }),

    initializeTheme() {
      const userTheme = getUserTheme();
      this.changeMode(userTheme);
      document.documentElement.setAttribute("data-layout-mode", userTheme);

      watchTheme((newTheme) => {
        this.changeMode(newTheme);
        document.documentElement.setAttribute("data-layout-mode", newTheme);
      });
    },
  }
};
</script>

<style>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>
